document.addEventListener('DOMContentLoaded', () => {
  const capabilityBtns = document.querySelectorAll('.capability');
  const capabilityInfos = document.querySelectorAll('.capability-info');
  const capabilityInfosContainer = document.querySelector('.capability-infos');
  const capabilityInfosBg = document.querySelector('.capability-infos-bg');
  const capabilityInfosCloseBtn = document.querySelector(
    '.capability-infos__btn'
  );

  document.querySelectorAll('.capability').forEach((capability) => {
    capability.addEventListener('click', () => {
      const capabilityId = capability.getAttribute('data-id');

      capabilityBtns.forEach((capabilityBtn) => {
        if (capabilityBtn.getAttribute('data-id') === capabilityId) {
          capabilityBtn.classList.add('capability--active');
        } else {
          capabilityBtn.classList.remove('capability--active');
        }
      });

      capabilityInfos.forEach((capabilityInfo) => {
        if (capabilityInfo.getAttribute('data-id') === capabilityId) {
          capabilityInfosContainer.classList.add('capability-infos--active');
          capabilityInfosBg.classList.add('capability-infos-bg--active');
          capabilityInfo.classList.add('capability-info--active');
          setTimeout(() => {
            capabilityInfosContainer.style.height =
              capabilityInfo.offsetHeight + 'px';
          }, 100);
        } else {
          capabilityInfo.classList.remove('capability-info--active');
        }
      });
    });
  });

  function closePopup() {
    capabilityInfosContainer.classList.remove('capability-infos--active');
    capabilityInfosBg.classList.remove('capability-infos-bg--active');
    capabilityBtns.forEach((capabilityBtn) => {
      capabilityBtn.classList.remove('capability--active');
    });
  }

  capabilityInfosBg.addEventListener('click', () => {
    closePopup();
  });

  capabilityInfosCloseBtn.addEventListener('click', () => {
    closePopup();
  });
});
